import { ObservableArray, View } from "binder"
import { KeepingPart, WarehouseKeepingDetailViewModel } from "./warehouseKeepingDetail-viewModel"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class WarehouseKeepingDetailView extends View<WarehouseKeepingDetailViewModel>{
    GetViewUniqueId(): string {
        return "V-17659F03-834F-4C43-B081-DF8E7415727E"
    }
    loadHtml(): string {
        let element = require('./warehouseKeepingDetail.html').default;
        let style = require('./warehouseKeepingDetail.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set warehouseKeepingId(v: string) { this._warehouseKeepingId = v; } public get warehouseKeepingId(): string { return this._warehouseKeepingId;} private _warehouseKeepingId: string;
    public set createTime(v: moment.Moment) { this._createTime = v; } public get createTime(): moment.Moment { return this._createTime;} private _createTime: moment.Moment;
    public set endTime(v: moment.Moment) { this._endTime = v; } public get endTime(): moment.Moment { return this._endTime;} private _endTime: moment.Moment;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId;} private _warehouseId: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName;} private _warehouseName: string;
    public set keepingParts(v: ObservableArray<KeepingPart>) { this._keepingParts = v; } public get keepingParts(): ObservableArray<KeepingPart> { return this._keepingParts;} private _keepingParts: ObservableArray<KeepingPart>;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;

    finalize() {
        this.dataContext.finalize();
    }
 
    addProducts() {
        this.dataContext.addProducts();
    }
 
    remaindReport() {
        this.dataContext.remaindReport();
    }
 
    close() {
        this.dataContext.closePopup();
    }
 
}
